<template>
  <div>
    <div class="admin_notice">
      <div class="back" v-if="!official" @click="backNotice()">
        <span>< </span>返回发布公告
      </div>

      <div
        class="boost_conent"
        v-for="(item, index) in listHistoryData.result"
        :key="index"
      >
        <div class="boost_conent_title">
          {{ item.title }}
          <div class="del" @click="open(item.id)" v-if="!official">
            <i class="el-icon-delete" style="color: #ff6767"></i>
            <span>删除</span>
          </div>
        </div>

        <div
          class="boost_conent_txt"
          :style="
            arrIndex.indexOf(index) == -1 ? officialNews_conents.style1 : ''
          "
          v-if="item.context.length > 215"
        >
          {{ item.context }}
        </div>
        <div class="boost_conent_txt" v-else>{{ item.context }}</div>
        <div
          class="read"
          v-if="item.context.length > 215"
          @click="readAll(index)"
        >
          <span :class="[{ morder: arrIndex.indexOf(index) == -1 }]">
            <span v-if="arrIndex.indexOf(index) == -1">...阅读更多</span>
          </span>
        </div>
        <div class="time">{{ item.update_date }}</div>
      </div>
    </div>

    <div style="text-align: right">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="listHistoryData.count"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: ["official", "listHistoryData"],
  data() {
    return {
      status: true,
      arrIndex: [],
      officialNews_conents: {
        style1: {
          display: "-webkit-box",
          "-webkit-box-orient": "vertical",
          "-webkit-line-clamp": "2",
          overflow: "hidden",
          "word-wrap": "break-word",
          "word-break": "break-all",
          color: "#999",
          "font-size": "16px",
          position: "relative",
        },
      },
    };
  },
  created() {},
  mounted() {
    console.log(this.listHistoryData.result);
  },
  methods: {
    open(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post(this.$api.api.delete_notice + "/" + id)
            .then((res) => {
              if (res.data.code != 1) {
                return this.$message.error(res.data.result);
              }
              this.$emit("listHistory");
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 返回公告页面
    backNotice() {
      this.$emit("backNotices", "false");
    },
    // 阅读更多
    readAll(index) {
      this.listHistoryData.result.forEach((element, i) => {
        if (i == index) {
          this.arrIndex.push(i);
        }
      });
      // this.status = false;
    },
    handleCurrentChange(val) {
      console.log(val);
      this.$emit("pagePageSize", val);
    },
  },
};
</script>

<style lang='scss' scoped>
.admin_notice {
  padding: 10px;
  .back {
    color: #6692ff;
    font-size: 14px;
    cursor: pointer;
    span {
      font-family: "SimSun" !important;
      font-weight: 600;
    }
  }
  .back:hover {
    color: #759dff;
  }
  .back:active {
    color: #537fed;
  }
  .boost_conent {
    margin-top: 20px;
    padding: 20px;
    background: #fff;
    position: relative;
    .boost_conent_title {
      color: #333;
      font-weight: bold;
      font-size: 18px;
      padding-bottom: 10px;
      position: relative;
      .del {
        color: #ff6767;
        position: absolute;
        top: 0px;
        right: 0px;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .boost_conent_txt {
      line-height: 27px;
      font-size: 14px;
      color: #999;
    }
    .read {
      position: absolute;
      right: 0%;
      top: 135px;
      z-index: 111;
      width: 840px;
      background: #fff;
      color: #398bf7;
      font-size: 14px;
      cursor: pointer;
    }
    .time {
      text-align: right;
      font-size: 14px;
      color: #999;
      padding-top: 6px;
    }
  }
}
.morder {
  color: #6692ff;
  font-size: 14px;
  cursor: pointer;
  position: absolute;
  bottom: 26px;
  right: 17px;
  z-index: 99;
  width: 80px;
  height: 20px;
  padding-left: 0px;
  background: #f7fafb;
}
.morder:hover {
  color: #759dff;
}
.morder:active {
  color: #537fed;
}
</style>
